"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_1 = __importDefault(require("@emotion/styled"));

var colors_1 = require("./colors");

var themes_1 = require("./themes");

var getThemePadding = function getThemePadding(theme) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _j;

  var paddingTop = (_c = (_b = (_a = theme) === null || _a === void 0 ? void 0 : _a.container) === null || _b === void 0 ? void 0 : _b.paddingTop, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.container.paddingTop);
  var paddingHorizontal = (_f = (_e = (_d = theme) === null || _d === void 0 ? void 0 : _d.container) === null || _e === void 0 ? void 0 : _e.paddingHorizontal, _f !== null && _f !== void 0 ? _f : themes_1.defaultTheme.container.paddingHorizontal);
  var paddingBottom = (_j = (_h = (_g = theme) === null || _g === void 0 ? void 0 : _g.container) === null || _h === void 0 ? void 0 : _h.paddingBottom, _j !== null && _j !== void 0 ? _j : themes_1.defaultTheme.container.paddingBottom);
  return paddingTop + "px " + paddingHorizontal + "px " + paddingBottom + "px";
};

var getPadding = function getPadding(props) {
  if (props.padding === undefined || props.padding === null) return props.theme && getThemePadding(props.theme);
  if (!props.padding) return 0;
  if (typeof props.padding === 'string') return props.padding;
  if (typeof props.padding === 'number') return props.padding + "px";
  return props.theme && getThemePadding(props.theme);
};

exports.Container = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  padding: ", ";\n  max-width: 100%;\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  color: ", ";\n  background-color: ", ";\n  min-height: ", ";\n  box-sizing: border-box;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n"], ["\n  flex: ", ";\n  display: ", ";\n  flex-direction: ", ";\n  align-items: ", ";\n  justify-content: ", ";\n  padding: ", ";\n  max-width: 100%;\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n  color: ", ";\n  background-color: ", ";\n  min-height: ", ";\n  box-sizing: border-box;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  grid-column-gap: ", ";\n  grid-row-gap: ", ";\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n\n  @media (min-width: ", "px) {\n    & {\n      max-width: ", ";\n    }\n  }\n"])), function (_a) {
  var flex = _a.flex;
  return !flex ? '0 0 auto' : typeof flex === 'boolean' ? 1 : flex;
}, function (_a) {
  var display = _a.display;
  return display || 'flex';
}, function (_a) {
  var direction = _a.direction;
  return direction || 'column';
}, function (_a) {
  var alignItems = _a.alignItems,
      align = _a.align;
  return alignItems || align || 'unset';
}, function (_a) {
  var justify = _a.justify;
  return justify || 'unset';
}, getPadding, function (props) {
  return colors_1.getColor(props, true);
}, function (props) {
  return colors_1.getBackgroundColorWithoutDefault(props);
}, function (_a) {
  var fullHeight = _a.fullHeight,
      minHeight = _a.minHeight,
      theme = _a.theme;

  var _b, _c;

  return fullHeight ? '100vh' : (_c = minHeight !== null && minHeight !== void 0 ? minHeight : (_b = theme.container) === null || _b === void 0 ? void 0 : _b.minHeight, _c !== null && _c !== void 0 ? _c : themes_1.defaultTheme.container.minHeight);
}, function (_a) {
  var gridTemplateColumns = _a.gridTemplateColumns;
  return gridTemplateColumns || 'unset';
}, function (_a) {
  var gridTemplateRows = _a.gridTemplateRows;
  return gridTemplateRows || 'unset';
}, function (_a) {
  var gridColumnGap = _a.gridColumnGap,
      display = _a.display;
  return gridColumnGap || (display === 'grid' ? '30px' : 'unset');
}, function (_a) {
  var gridRowGap = _a.gridRowGap,
      display = _a.display;
  return gridRowGap || (display === 'grid' ? '30px' : 'unset');
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.thresholds) === null || _c === void 0 ? void 0 : _c.sm, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.thresholds.sm;
}, function (prop) {
  return prop.fluid ? 'auto' : prop.theme.container.smWidth + 'px';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.thresholds) === null || _c === void 0 ? void 0 : _c.md, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.thresholds.md;
}, function (prop) {
  return prop.fluid ? 'auto' : prop.theme.container.mdWidth + 'px';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.thresholds) === null || _c === void 0 ? void 0 : _c.lg, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.thresholds.lg;
}, function (prop) {
  return prop.fluid ? 'auto' : prop.theme.container.lgWidth + 'px';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.thresholds) === null || _c === void 0 ? void 0 : _c.xl, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.thresholds.xl;
}, function (prop) {
  return prop.fluid ? 'auto' : prop.theme.container.xlWidth + 'px';
}, function (_a) {
  var theme = _a.theme;

  var _b, _c, _d;

  return _d = (_c = (_b = theme) === null || _b === void 0 ? void 0 : _b.thresholds) === null || _c === void 0 ? void 0 : _c.xxl, _d !== null && _d !== void 0 ? _d : themes_1.defaultTheme.thresholds.xxl;
}, function (prop) {
  return prop.fluid ? 'auto' : prop.theme.container.xxlWidth + 'px';
});
var templateObject_1;